import { Link, useParams } from 'react-router-dom';
import { useEventBySlug } from '@/lib/queries';
import { useAuth } from '@/lib/auth';
import { EventDetails } from '@/components/EventDetails';
import { ErrorNote, Spinner } from '@/components/Layout';

/** /events/:slug, public. The page egka.org.uk and social posts link to. */
export function EventPage() {
  const { slug = '' } = useParams();
  const event = useEventBySlug(slug);
  const { session } = useAuth();
  if (event.isLoading) return <Spinner />;
  if (!event.data) return <ErrorNote>We couldn't find that event. It may have finished or been taken down. <Link to="/events" className="underline">See upcoming events</Link>.</ErrorNote>;
  return (
    <div className="space-y-4">
      <Link to="/events" className="text-sm text-ink-500 hover:underline">← All events</Link>
      <EventDetails e={event.data} bookHref={session ? `/events/${event.data.id}/book` : `/signin?next=/events/${event.data.id}/book`} gradingHref={session ? `/events/${event.data.id}/grading` : `/signin?next=/events/${event.data.id}/grading`} />
    </div>
  );
}
